/* import __COLOCATED_TEMPLATE__ from './topic-footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();